import { Routes } from '@angular/router';
import { ADMIN_ROUTES } from './layouts/admin/admin.routes';
import { authGuard } from './core/guards/auth.guard';
import { authNoGuard } from './core/guards/auth-no.guard';
import { mailOperatorRestrictionGuard } from './core/guards/mail-operator.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    canActivate: [authNoGuard],
    loadComponent: () => import('./layouts/auth/auth').then(m => m.Auth),
    loadChildren: () => import('./layouts/auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    canActivateChild: [mailOperatorRestrictionGuard],
    loadComponent: () => import('./layouts/admin/admin').then(m => m.Admin),
    children: ADMIN_ROUTES,
  },
  {
    path: 'reset-password',
    redirectTo: (route) => `/auth/login?token=${route.queryParams['token']}`,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'admin',
  },
];
